import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { AppContextProvider } from '../../../Services/AppContext';
import { store } from '../../../store/store';
import CompatibilityCheck from './CompatibilityCheck';
import { loadDOMComponent } from '../../../helpers';

loadDOMComponent({
	selector: 'react-compatibility-check',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const appLinkIos = container.getAttribute('appLinkIos');
		const appLinkAndroid = container.getAttribute('appLinkAndroid');
		const location = container.getAttribute('location');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<CompatibilityCheck
						appLinkAndroid={appLinkAndroid}
						appLinkIos={appLinkIos}
						location={location}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
